export default __webpack_public_path__ + "static/media/original_oval.98301d00.webp";